/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Auth_ScopingInputs */

const en_svchip_auth_scoping = /** @type {(inputs: Svchip_Auth_ScopingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auth scoping`)
};

const ar_svchip_auth_scoping = /** @type {(inputs: Svchip_Auth_ScopingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نطاق الصلاحيات`)
};

const bn_svchip_auth_scoping = /** @type {(inputs: Svchip_Auth_ScopingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অথ স্কোপিং`)
};

const de_svchip_auth_scoping = /** @type {(inputs: Svchip_Auth_ScopingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auth-Scoping`)
};

const es_svchip_auth_scoping = /** @type {(inputs: Svchip_Auth_ScopingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alcance de autenticación`)
};

const fr_svchip_auth_scoping = /** @type {(inputs: Svchip_Auth_ScopingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portée de l'authentification`)
};

const pt_svchip_auth_scoping = /** @type {(inputs: Svchip_Auth_ScopingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escopo de autenticação`)
};

const zh_svchip_auth_scoping = /** @type {(inputs: Svchip_Auth_ScopingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`身份验证范围`)
};

const tr_svchip_auth_scoping = /** @type {(inputs: Svchip_Auth_ScopingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kimlik doğrulama kapsamı`)
};

const ru_svchip_auth_scoping = /** @type {(inputs: Svchip_Auth_ScopingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Область аутентификации`)
};

const pl_svchip_auth_scoping = /** @type {(inputs: Svchip_Auth_ScopingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zakres uwierzytelniania`)
};

/**
* | output |
* | --- |
* | "Auth scoping" |
*
* @param {Svchip_Auth_ScopingInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_auth_scoping = /** @type {((inputs?: Svchip_Auth_ScopingInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Auth_ScopingInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_auth_scoping(inputs)
	if (locale === "bn") return bn_svchip_auth_scoping(inputs)
	if (locale === "de") return de_svchip_auth_scoping(inputs)
	if (locale === "es") return es_svchip_auth_scoping(inputs)
	if (locale === "fr") return fr_svchip_auth_scoping(inputs)
	if (locale === "pt") return pt_svchip_auth_scoping(inputs)
	if (locale === "zh") return zh_svchip_auth_scoping(inputs)
	if (locale === "tr") return tr_svchip_auth_scoping(inputs)
	if (locale === "ru") return ru_svchip_auth_scoping(inputs)
	if (locale === "pl") return pl_svchip_auth_scoping(inputs)
	return en_svchip_auth_scoping(inputs)
});